module.exports = __webpack_public_path__ + "img/nine.997b943b.png";